import { useFormik } from "formik";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { changePassword } from "../../redux/slice/user/userSlice";

const ChangePassword = ({ modal_id }) => {
  const close = useRef();
  const form = useRef();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.auth?.user);
  const { isChanged } = useSelector((state) => state?.user);
  const navigate = useNavigate();

  const onSubmit = (values) => {
    let payload = { ...values, id: user?.id };
    dispatch(changePassword(payload));
    // close.current.click()
  };

  const validationScehma = Yup.object().shape({
    oldpassword: Yup.string().required("Old Password cannot be blank"),
    password: Yup.string()
      .notOneOf(
        [Yup.ref("oldpassword")],
        "Password cannot be the same as the old password"
      )
      .required("Password cannot be blank"),
    password_confirmation: Yup.string()
      .oneOf(
        [Yup.ref("password")],
        "Password confirmation must match the password"
      )
      .required("Password confirmation cannot be blank"),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      oldpassword: "",
      password: "",
      password_confirmation: "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  useEffect(() => {
    if (isChanged) {
      resetForm();
      form.current.reset();
      close.current.click();
    }
  }, [isChanged, resetForm]);

  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable' role='document'>
          <form
            className='modal-content rounded-4 text-dark'
            ref={form}
            onSubmit={handleSubmit}
          >
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                Change Password
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                onClick={() => {
                  resetForm();
                  form.current.reset();
                }}
                style={{ padding: "0px 3px" }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body'>
              <div className='px-3'>
                <div className='row mb-2'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='username'
                      className={`form-label mt-1  ${
                        errors?.name && touched?.name && "text-danger"
                      }`}
                    >
                      Old Password
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='password'
                      id='oldpassword'
                      name='oldpassword'
                      className={`form-control ${
                        errors?.oldpassword &&
                        touched?.oldpassword &&
                        "is-invalid"
                      }`}
                      value={values.oldpassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.oldpassword && touched?.oldpassword && (
                      <p className='invalid-feedback mb-0'>
                        {errors?.oldpassword}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-2'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='description'
                      className={`form-label mt-1  ${
                        errors?.description &&
                        touched?.description &&
                        "text-danger"
                      }`}
                    >
                      New Password
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='password'
                      id='password'
                      name='password'
                      className={`form-control ${
                        errors?.password && touched?.password && "is-invalid"
                      }`}
                      value={values?.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors?.password && (
                      <p className='invalid-feedback mb-0'>
                        {errors?.password}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='description'
                      className={`form-label mt-1  ${
                        errors?.description &&
                        touched?.description &&
                        "text-danger"
                      }`}
                    >
                      Repeat Password
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='password'
                      id='password_confirmation'
                      name='password_confirmation'
                      className={`form-control ${
                        errors?.password_confirmation &&
                        touched?.password_confirmation &&
                        "is-invalid"
                      }`}
                      value={values?.password_confirmation}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors?.password_confirmation && (
                      <p className='invalid-feedback mb-0'>
                        {errors?.password_confirmation}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer me-3 mt-4'>
              <button
                type='button'
                className='btn btn-secondary btn-sm rounded-3'
                data-bs-dismiss='modal'
                onClick={() => {
                  resetForm();
                  form.current.reset();
                }}
              >
                Close
              </button>
              <button
                type='submit'
                className='btn btn-primary btn-sm rounded-3'
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
